
export default {
  model: {
    prop: 'filters',
  },

  props: {
    label: { type: String, default: 'Filtres' },
    filters: { type: Array, default: () => [] },
  },

  data() {
    return {
      open: false,
    }
  },
  computed: {
    filtersCount() {
      return this.filters.filter(filter => filter.enabled).length;
    },

    filtersText() {
      if (this.filtersCount === 0) {
        return 'Aucun filtre actif';
      } else if (this.filtersCount === 1) {
        return '1 filtre actif';
      } else {
        return `${this.filtersCount} filtres actifs`;
      }
    },
  }
}
